<div class="taxes-wrapper">
	<div class="text-container">
		<div class="left-container">
			<div class="text-section mt-2">
				<span class="title">{{data().title}}</span>
				<span class="message">{{ data().text }}</span>
			</div>
		</div>
		<div class="right-container">
			<div class="buttons-section">
				<button class="btn btn-primary buttons" (click)="handleCTAClick()"> {{data().cta_title}}</button>
			</div>
		</div>
	</div>
</div>
